import { all, fork } from "redux-saga/effects";

//public
import AuthSaga from "./auth/saga";
import UserSaga from "./users/saga";
import GroupSaga from "./groups/saga";
import ReleaseSaga from "./releases/saga";
import ReleaseNoteSaga from "./releaseNotes/saga";
import NotificationSaga from "./notifications/saga";
import CommentSaga from "./comments/saga";
import ProjectSaga from "./projects/saga";
import ProductSaga from "./products/saga";
import BrandSaga from "./brands/saga";
import ComponentSaga from "./components/saga";
import DocumentSaga from "./documents/saga";
import CategorySaga from "./categories/saga";
import ConfigurationSaga from "./configurations/saga";
import SectorSaga from "./sectors/saga";
import AgencySaga from "./agencies/saga";
import DepartmentSaga from "./departments/saga";
import LineSaga from "./lines/saga";
import QuoteSaga from "./quotes/saga";
import DashboardSaga from "./dashboard/saga";



export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(UserSaga),
    fork(GroupSaga),
    fork(ReleaseSaga),
    fork(ReleaseNoteSaga),
    fork(NotificationSaga),
    fork(CommentSaga),
    fork(ProjectSaga),
    fork(ProductSaga),
    fork(BrandSaga),
    fork(ComponentSaga),
    fork(CategorySaga),
    fork(DocumentSaga),
    fork(ConfigurationSaga),
    fork(SectorSaga),
    fork(AgencySaga),
    fork(DepartmentSaga),
    fork(LineSaga),
    fork(QuoteSaga),
    fork(DashboardSaga),
  ]);
}
